import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ifp-loyalty-reward-widget",
  templateUrl: "./loyalty-reward-widget.component.html",
  styleUrls: ["./loyalty-reward-widget.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoyaltyRewardWidgetComponent {

  @Input()
  interestRateReduction: number;

  @Output() 
  viewDetails = new EventEmitter<void>();

  onViewDetails(): void {
    this.viewDetails.emit();
  }
}
